<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <b-link class="brand-logo">
        <b-img
fluid
:src="geolimLogo"
alt="Logo"
height="40px"
width="40px"
/>
        <h2 class="brand-text text-primary ml-1">
          Geolims
        </h2>
      </b-link>
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Forgot password V2"
          />
        </div>
      </b-col>
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title class="mb-1">
            Forgot Password? 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            Enter your email and we'll send you instructions to reset your password
          </b-card-text>

          <validation-observer ref="simpleRules">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <b-form-group
                label="Email"
                label-for="forgot-password-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="forgot-password-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="forgot-password-email"
                    placeholder="john@example.com"
                    :disabled="isLoading"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="isLoading"
              >
                <b-spinner
                  v-if="isLoading"
                  small
                  class="mr-1"
                />
                <span v-if="isLoading">Sending...</span>
                <span v-else>Send New Password</span>
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> Back to login
            </b-link>
          </p>
        </b-col>
      </b-col>
      </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton, BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import store from '@/store/index'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    BSpinner, // Added Spinner component
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      geolimLogo: require('@/assets/images/logo/geolim.png'),
      userEmail: '',
      isLoading: false, // Added loading state
      // validation rules
      required,
      email,
    }
  },
  computed: {
    imgUrl() {
      // Fixed: Removed side-effect. Directly return the required image based on store state.
      if (store.state.appConfig.layout.skin === 'dark') {
        return require('@/assets/images/pages/forgot-password-v2-dark.svg')
      }
      return require('@/assets/images/pages/forgot-password-v2.svg')
    },
  },
  methods: {
    async validationForm() {
      const success = await this.$refs.simpleRules.validate()
      
      if (success) {
        this.isLoading = true // Start loading

        const payload = { Email: this.userEmail }
        
        try {
          // No custom headers needed usually, Axios handles JSON content-type automatically
          await axios.post(process.env.VUE_APP_API_FORGOT_PASSWORD_URL, payload)
          
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Password Reset Successful', // Fixed Grammar
              icon: 'CheckCircleIcon', // More appropriate icon
              variant: 'success',
              text: 'A new password has been sent to your email address.',
            },
          })

          // Optional: Redirect user to login after success
          setTimeout(() => {
            this.$router.push({ name: 'auth-login' })
          }, 2000)
        } catch (error) {
          console.error('Reset Password Error:', error)
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Request Failed',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: error.response?.data?.message || 'Something went wrong. Please check your email and try again.',
            },
          })
        } finally {
          this.isLoading = false // Stop loading regardless of success or failure
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>